import { render, staticRenderFns } from "./CommentAnswer.vue?vue&type=template&id=9fd74dac&scoped=true"
import script from "./CommentAnswer.vue?vue&type=script&lang=js"
export * from "./CommentAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd74dac",
  null
  
)

export default component.exports